import React, { useState, useEffect } from 'react';
import { format } from 'date-fns';
import styled from 'styled-components';
import CustomTable from '../../components/Table';
import CustomModal from '../../components/modal/CustomModal';
import { DetailPayment } from '../../components/modal/DetailPaymentModal';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { registerLocale } from 'react-datepicker';
import ko from 'date-fns/locale/ko';
import Pagination from '../../components/Pagination';
import SettlementController, {
  CategorySaleType,
  DailyPayment,
  DailySettle,
  GetSalesAnalysisByCateType,
  SalesData,
} from '../../controller/SettlementController';
import OrderController, { Order } from '../../controller/OrderController';
import ExcelJS from 'exceljs';
import moment from 'moment-timezone';
import 'moment/locale/ko';
import ToggleButton from '../../components/Toggle';
import toast, { Toaster } from 'react-hot-toast';
registerLocale('ko', ko);

const ONE_DAY_IN_MS = 1000 * 60 * 60 * 24;

const CategorySaleWrapper = () => {
  //테이블 헤더
  const tableHeader = ['순위', '분류명', '총수량', '총매출액'];

  //선택된 날짜
  const currentDate = new Date();
  const [period, setPeriod] = useState<Date[] | any>([
    new Date(currentDate).setMonth(currentDate.getMonth() - 1),
    currentDate,
  ]);

  const [orderBy, setOrderBy] = useState<boolean>(false); //true->1 결제일기준 , false->0 영업일기준

  // 기간 분석 내역
  const [saleAnalysisList, setSaleAnalysisList] = useState<CategorySaleType[]>([]);

  // 현재 페이지
  const [currentPage, setCurrentPage] = useState<number>(1);

  // 당일 매출건수의 페이지 개수
  const [pageCount, setPageCount] = useState<number>(0);

  // 한 페이지 당 표현해줄 아이템개수
  const [itemPerPage, setItemPerPage] = useState<number>(20);

  /**
   *  * 기능: 조회 버튼 클릭시 기간 분석 API 호출
   */
  const searchData = () => {
    getSalesAnalysis(period[0], period[1], itemPerPage - itemPerPage + 1, itemPerPage, orderBy);
    setCurrentPage(1);
  };

  /**
   * * 기능 : 기간내의 분석 데이터 API 호출
   *
   * @param start_date 시작일자 "YYYY-MM-DD"
   * @param end_date 마감일자 "YYYY-MM-DD"
   * @param start_rn offset
   * @param end_rn offset
   * @param order_by 순위
   * @returns
   */
  const getSalesAnalysis = async (
    start_date: Date,
    end_date: Date,
    start_rn: number,
    end_rn: number,
    order_by: boolean,
  ) => {
    try {
      const oData = {
        start_date: moment(start_date).format('YYYY-MM-DD'),
        end_date: moment(end_date).format('YYYY-MM-DD'),
        start_rn,
        end_rn,
        order_by: order_by ? 1 : 0,
      };
      console.log('oData', oData);
      const response = await SettlementController.getCategorySale(oData);

      if (response.data.ok) {
        let periodAnalysisSaleData: GetSalesAnalysisByCateType = response.data.data;

        // 페이지 네이션 세팅
        let pageCount = Math.ceil(periodAnalysisSaleData.total_rn / itemPerPage);

        setPageCount(pageCount);
        setSaleAnalysisList(JSON.parse(JSON.stringify(periodAnalysisSaleData.items)));
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };

  /**
   * 페이지 버튼 클릭시 동작
   *
   * @param selected
   */
  const pressPage = async (selected: { selected: number }) => {
    await getSalesAnalysis(
      period[0],
      period[1],
      (selected.selected + 1) * itemPerPage - itemPerPage + 1,
      (selected.selected + 1) * itemPerPage,
      orderBy,
    );
    setCurrentPage(selected.selected + 1);
  };

  const renderTableItem = () => {
    return (
      <>
        {saleAnalysisList.length > 0 ? (
          saleAnalysisList.map((analysisSaleItem: CategorySaleType, index: number) => (
            <>
              <tr key={index} className="webTableWrap">
                <td style={{ textAlign: 'center' }}>{analysisSaleItem.rn}</td> {/** 순위  */}
                <td style={{ textAlign: 'left' }}>{analysisSaleItem.name}</td> {/** 상품명  */}
                <td style={{ textAlign: 'center' }}>{analysisSaleItem.total_product_quantity}건</td>
                {/** 총수량  */}
                <td style={{ textAlign: 'right' }}>
                  {Number(analysisSaleItem.total_amount).toLocaleString()}원
                </td>
                {/** 총매출액  */}
              </tr>
            </>
          ))
        ) : (
          <td colSpan={14} className="noneList">
            <p>조회된 날짜에 결제 내역이 없습니다.</p>
          </td>
        )}
      </>
    );
  };

  useEffect(() => {
    getSalesAnalysis(
      period[0],
      period[1],
      currentPage * itemPerPage - itemPerPage + 1,
      currentPage * itemPerPage,
      orderBy,
    );
  }, []);

  return (
    <Style>
      <div className="rightContentWrap">
        <div className="title">
          <h1>분류별 매출</h1>
          <button
            onClick={async () => {
              const oData = {
                start_date: period[0],
                end_date: period[1],
                start_rn: null,
                end_rn: null,
                order_by: orderBy ? 1 : 0,
              };

              const response = await SettlementController.getCategorySale(oData);

              if (response.data.ok) {
                let periodAnalysisSaleData: GetSalesAnalysisByCateType = response.data.data;

                // 데이터를 엑셀로 변환하여 다운로드
                const workbook = new ExcelJS.Workbook();
                const worksheet = workbook.addWorksheet('Sheet 1');

                worksheet.addRow(tableHeader.slice(0, tableHeader.length));
                for (let i = 0; i < periodAnalysisSaleData.items.length; i++) {
                  worksheet.addRow([
                    periodAnalysisSaleData.items[i].rn,
                    periodAnalysisSaleData.items[i].name,
                    periodAnalysisSaleData.items[i].total_product_quantity,
                    periodAnalysisSaleData.items[i].total_amount,
                  ]);
                }

                // 엑셀 파일로 저장
                workbook.xlsx.writeBuffer().then((buffer) => {
                  const blob = new Blob([buffer], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                  });
                  const url = window.URL.createObjectURL(blob);
                  const link = document.createElement('a');
                  link.href = url;
                  link.setAttribute(
                    'download',
                    `분류별매출_${moment(period[0]).format('YYYY-MM-DD')}_${moment(
                      period[1],
                    ).format('YYYY-MM-DD')}.xlsx`,
                  );
                  document.body.appendChild(link);
                  link.click();
                });
              }
            }}
            className="excelDownload">
            <img src={`${process.env.PUBLIC_URL}/svg/ic_excel.svg`} alt="엑셀 다운로드 아이콘" />
            <h3>엑셀 다운로드</h3>
          </button>
        </div>
        <div className="contentContainer">
          <div className="searchInputWrap">
            <div className="searchDate">
              <p>날짜 조회</p>
              <DatePicker
                selectsRange={true}
                startDate={period[0]}
                endDate={period[1]}
                onChange={async (update) => {
                  setPeriod(update);

                  if (update[0] !== null && update[1] !== null) {
                    const timeDiff = Math.abs(update[0].getTime() - update[1].getTime());
                    // 시간 차이를 일 단위로 계산
                    const daysDiff = Math.ceil(timeDiff / ONE_DAY_IN_MS);
                    if (daysDiff > 32) {
                      toast.error('최대 1개월 조회 가능합니다.');
                      update[0] = new Date(update[1].getTime() - ONE_DAY_IN_MS * 32);
                    }
                    await getSalesAnalysis(
                      update[0],
                      update[1],
                      // null,
                      itemPerPage - itemPerPage + 1,
                      itemPerPage,
                      orderBy,
                    );
                  }
                  setCurrentPage(1);
                }}
                dateFormat="yyyy-MM-dd"
                isClearable={false}
                locale="ko"
                monthsShown={1}
                maxDate={new Date()}
              />
            </div>
            <button onClick={searchData}>조회</button>
          </div>
          {/* <TotalSales /> */}
          <ToggleButton
            toggle1="매출순"
            toggle2="판매순"
            defaultOn={orderBy}
            onToggle={async (isOn: boolean) => {
              await getSalesAnalysis(
                period[0],
                period[1],
                // null,
                itemPerPage - itemPerPage + 1,
                itemPerPage,
                isOn,
              );
              setOrderBy(isOn);
              setCurrentPage(1);
              // setInputValue('');
            }}
          />
          <CustomTable tableHeader={tableHeader} renderTableItem={renderTableItem} />

          <div className="paginationWrap">
            <Pagination
              pageCount={pageCount}
              forcePage={currentPage - 1}
              handlePageClick={pressPage}
            />
          </div>
        </div>
      </div>
    </Style>
  );
};

export default CategorySaleWrapper;

const Style = styled.div`
  td {
    text-align: right;
  }

  .title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 26px;

    h1 {
      margin-bottom: 0;
    }
    .excelDownload {
      display: flex;
      align-items: center;
      padding: 8px 16px;
      border-radius: 4px;
      background: #ecfdf3;
      border: 1px solid #027a48;
      outline: none;

      h3 {
        margin-left: 6px;
        color: #027a48;
        font-size: 16px;
        font-weight: 600;
      }
    }
  }
  .searchInputWrap {
    width: 100%;
    margin-bottom: 20px;
    padding: 16px;
    display: flex;
    align-items: flex-end;
    justify-content: flex-start;
    background: #f9fafb;
    border: 1px solid #eaecf0;
    border-radius: 4px;

    button {
      width: 20%;
      margin-left: auto;
      padding: 10px 40px;
      background: #000;
      color: #fff;
      border-radius: 4px;
      font-size: 18px;
      font-weight: 700;
      border: none;
      outline: none;
    }
  }
  .searchDate {
    width: 100%;

    p {
      margin-bottom: 8px;
    }
  }
  .searchDate:nth-child(1) {
    flex: 0 0 30%;
    input {
      width: 100%;
    }
  }
  input {
    width: 90%;
    padding: 10px;
    border: 1px solid #a6abb2;
    border-radius: 4px;
  }

  .react-datepicker button {
    background: none;
  }

  .detailOrder {
    width: 100%;
    padding: 8px 0;
    background-color: #000;
    border: none;
    outline: none;
    color: #fff;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 500;
  }
  .noneList {
    width: 100%;
    padding: 50px 0;
    text-align: center;

    p {
      font-size: 18px;
      font-weight: 600;
    }
  }

  @media (max-width: 900px) {
    .react-datepicker-wrapper {
      width: 100% !important;
    }
    .searchInputWrap {
      width: 100%;
      flex-direction: column;

      input,
      button {
        width: inherit;
        margin: 4px 0 12px 0;
      }
    }

    thead tr th {
      font-size: 12px;
    }
  }
`;
